/**
 * @generated SignedSource<<3160edbe41f76e016ef9343496feb796>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useRetryLastMessageMutation$variables = {
  conversationId: string;
};
export type useRetryLastMessageMutation$data = {
  readonly askCopilotRetryLastMessage: {
    readonly conversation: {
      readonly " $fragmentSpreads": FragmentRefs<"AskFellowPanelInnerFragment">;
    };
  } | null;
};
export type useRetryLastMessageMutation = {
  response: useRetryLastMessageMutation$data;
  variables: useRetryLastMessageMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "conversationId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "conversationId",
    "variableName": "conversationId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useRetryLastMessageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AskCopilotRetryLastMessage",
        "kind": "LinkedField",
        "name": "askCopilotRetryLastMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AskFellowPanelInnerFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useRetryLastMessageMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AskCopilotRetryLastMessage",
        "kind": "LinkedField",
        "name": "askCopilotRetryLastMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AskCopilotConversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotMessage",
                "kind": "LinkedField",
                "name": "messages",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "role",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "content",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentJson",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pending",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "createdAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isResponse",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "contentForDisplay",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "error",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userRating",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AskCopilotConversationContext",
                "kind": "LinkedField",
                "name": "context",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "object",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "haveOngoingBotlessRecording",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "reachedMessageLimit",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4906128306a00fcb01c4f1691fcd51c1",
    "id": null,
    "metadata": {},
    "name": "useRetryLastMessageMutation",
    "operationKind": "mutation",
    "text": "mutation useRetryLastMessageMutation(\n  $conversationId: ID!\n) {\n  askCopilotRetryLastMessage(conversationId: $conversationId) {\n    conversation {\n      ...AskFellowPanelInnerFragment\n      id\n    }\n  }\n}\n\nfragment AskFellowPanelInnerFragment on AskCopilotConversation {\n  id\n  title\n  updatedAt\n  messages {\n    id\n    role\n    content\n    contentJson\n    pending\n    createdAt\n    isResponse\n    contentForDisplay\n    error\n    ...AskFellowPanelInner_ChatMessage_message\n  }\n  ...SuggestedQuestionsWrapper_conversation\n  context {\n    haveOngoingBotlessRecording\n  }\n  reachedMessageLimit\n}\n\nfragment AskFellowPanelInner_ChatMessage_message on AskCopilotMessage {\n  id\n  role\n  content\n  contentJson\n  contentForDisplay\n  pending\n  isResponse\n  error\n  ...AskFellowPanelInner_RatingButtons_message\n}\n\nfragment AskFellowPanelInner_RatingButtons_message on AskCopilotMessage {\n  id\n  userRating\n}\n\nfragment SuggestedQuestionsWrapper_conversation on AskCopilotConversation {\n  context {\n    object {\n      __typename\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "91913c703520f843221a63591d321ce6";

export default node;
